import { Link } from "react-router-dom";
import { XCircle, ArrowRight } from "lucide-react";
import { useSeo } from "../lib/useSeo";

export default function CheckoutCancel() {
  useSeo({ title: "Checkout cancelled", noindex: true });
  return (
    <main className="py-20" data-testid="checkout-cancel-page">
      <div className="max-w-2xl mx-auto px-5 sm:px-8 lg:px-12 xl:px-16 2xl:px-24 text-center">
        <div className="bnp-card p-10">
          <XCircle className="mx-auto text-[#447694]" size={32} />
          <h1 className="font-display text-2xl md:text-3xl text-[#04273d] mt-4 font-semibold">Checkout cancelled.</h1>
          <p className="text-[#447694] mt-3">
            No payment was taken. When you're ready, you can restart the process below.
          </p>
          <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
            <Link to="/pricing" className="btn-primary">View pricing <ArrowRight size={14} /></Link>
            <Link to="/" className="btn-secondary">Back to home</Link>
          </div>
        </div>
      </div>
    </main>
  );
}
